<script setup lang="ts">
    import { inject } from 'vue'
    import { useI18n } from 'vue-i18n'
    import PkAvatar from './PkAvatar.vue'
    import { chatbotContextKey } from './constants'

    const { t: $t } = useI18n({ useScope: 'global' })
    const ctx = inject(chatbotContextKey)!
</script>

<template>
    <div class="flex flex-col flex-1 min-h-0 overflow-y-auto p-md gap-md">
        <p class="text-sm font-semibold text-word-2">
            {{ $t('label.profile') }}
        </p>

        <div class="flex flex-col items-center gap-sm p-lg">
            <PkAvatar
                modifiers="surface ring"
                class="w-48 h-48"
                :name="ctx.name.value"
                :img-src="ctx.agentInterface.value?.logo" />
            <strong
                v-if="ctx.name.value"
                class="text-base font-semibold text-word-1">
                {{ ctx.name.value }}
            </strong>
        </div>

        <slot />
    </div>
</template>
